import {numberFormat} from "./Components/Core/common";

require('./base');

import events from "./base";

import Agent from "./Components/Core/agent";
import {notice} from "./Components/UI/notice";

const {modal} = require("./Components/UI/modal");

let currentmodal = null;


const proto = HTMLElement.prototype;
const addListener = proto.addEventListener;
const removeListener = proto.removeEventListener;

proto.addEventListener = function (type, callback, useCapture) {
    if (!this._listeners) {
        this._listeners = {};
    }
    if (!(type in this._listeners)) {
        this._listeners[type] = [];
    }

    if (this._listeners[type].indexOf(callback) === -1) {
        this._listeners[type].push(callback);
    }

    addListener.call(this, type, callback, useCapture);
};

proto.removeEventListener = function (type, callback, useCapture) {
    const index = this._listeners && type in this._listeners ? this._listeners[type].indexOf(callback) : -1;

    if (index !== -1) {
        this._listeners[type].splice(index, 1);
    }

    removeListener.call(this, type, callback, useCapture);
};

proto.hasEventListener = function (type) {
    return !!(this._listeners && type in this._listeners && this._listeners[type].length || typeof this['on' + type] === 'function');
};

const openFormEvent = button => {
    button.classList.add('preloader');
    Agent.post('api/v1/wholesales/form', {})
        .then(e => e.json())
        .then(e => {
            if (e.success === true) {
                modal({
                    message: e.data,
                    size: 'modal-xl',
                    header: () => `<div class="modal-header"><div class="fs-lg-24 fs-sm-20 fs-18 lh-0_9 mb-0 fw-bl">Выберите кварцвиниловую плитку</div>
                                        <button class="btn-close position-absolute end-0 top-0 mt-10 me-10 border-0 p-0 ms-auto d-flex p-10 bg-transparent"
                                                data-bs-dismiss="modal">
                                            <i class="icon u_multiply fs-sm-24 fs-20 text-main"></i>
                                        </button></div>`,
                    showEvent: (to, modal) => {
                        currentmodal = modal;
                        to.querySelectorAll('.spoiler').forEach(item => {
                            let btn = item.querySelector('.spoiler-btn');
                            let block = item.querySelector('.spoiler-block');
                            btn.addEventListener('click', () => {
                                btn.classList.toggle('active');
                                if (!block.classList.contains('active')) {
                                    item.classList.toggle('active');
                                    block.classList.add('active');
                                    block.style.height = 0;
                                    block.style.height = block.scrollHeight + 'px';
                                } else {
                                    block.style.height = '0px';
                                    setTimeout(function () {
                                        block.classList.remove('active');
                                        item.classList.toggle('active');
                                    }, 350);
                                }
                            });
                        });

                        if (to.querySelector('.js_filter_form')) {
                            const filter = async () => await import("./Components/Filter/filter");
                            filter().then(f => f.init(events));
                        }

                        events.dispatch('filter.search');
                    }
                });
            } else {
                modal(e.message);
            }
        })
        .finally(() => button.classList.remove('preloader'));
};

document.querySelector('.js_open_wholesales_form').addEventListener('click', event => openFormEvent(event.target));
const productTemplate = (url, title, photo, price, discountPrice, options) => {

    let discountPriceHtml = '';
    if (price > discountPrice) {
        discountPriceHtml = `<span class="text-decoration-line-through">${discountPrice} руб./м2</span>`;
    }
    let optionsHtml = '';
    options.forEach(option => {
        let unit = '';
        if (option.units.length) {
            unit = `, ${option.units}`;
        }
        let value = '';
        if (option.data === 'Да') {
            value = ` <span class="d-flex lh-1"><i class="icon success fs-12"></i></span>`;
        } else if (option.data === 'Нет') {
            value = `<span class="d-flex lh-1"><i class="icon close fs-12"></i></span>`;
        } else {
            value = `<span class="fs-12">${option.data}</span>`;
        }

        optionsHtml += `<div class="characteristic-line product d-flex justify-content-between align-items-baseline position-relative flex-grow-1">
                             <span><span class="fs-12">${option.parameter_name}${unit}</span></span>
                             <span>${value}</span>
                        </div>`;
    });
    return `<div class="catalog-item d-flex flex-column flex-grow-1 bg-white">
                  <div class="catalog-item-img position-relative overflow-hidden">
                      <a href="${url}">
                          <span class="d-block ratio ratio-16x9">
                            <img  src="${photo}" alt="${title}">
                          </span>
                      </a>
                  </div>
                  <div class="p-15 p-md-20 d-flex flex-column gap-8 gap-md-15 flex-grow-1">
                      <a class="fs-12 fs-md-14 fw-rg" href="${url}"
                        >
                        ${title}
                      </a>
                      <div class="catalog-item-char d-flex flex-column gap-4">
                          ${optionsHtml}
                      </div>
                      <div class="d-flex flex-column gap-5 flex-grow-1">
                          <div class="fs-10 fs-sm-12 o-0_7">Цена: 
                            ${discountPriceHtml}
                          </div>
                          <div class="fs-14 fs-md-16 fw-bl text-main">${price} <span class="fs-12 fw-rg">руб./м2</span></div>
                      </div>
                      <div class="d-flex flex-column flex-sm-row justify-content-between gap-10">
                          <button type="button" class="btn-light border-0 px-xl-15 py-xl-15 px-10 py-10 d-flex justify-content-center align-items-center fs-12 fs-sm-14 lh-1 fw-rg flex-grow-1 js_open_wholesales_form">
                            Выбрать другую плитку
                          </button>
                      </div>
                  </div>
            </div>`;
};

let squareResult = document.querySelectorAll('.js_square_result');
let wholesalesProductBlock = document.querySelector('.js_wholesales_product_block');
let discountPercentResult = document.querySelector('.js_all_discount');
let discountAction = document.querySelector('.js_discount_action');
let stockSquare = document.querySelector('.js_stock_square');
let squareWithStock = document.querySelector('.js_square_with_stock');
let square = document.querySelector('[name="square"]');
let lengthInput = document.querySelector('[name="length"]');
let width = document.querySelector('[name="width"]');
let product = document.querySelector('[name="product"]');

let printData = () => {
    let currentSquare = parseFloat(square.value);

    let percentDiscount = 0;
    let currentPercentDiscount = parseFloat(discountPercentResult.dataset.discount);

    if (currentSquare >= 50 && currentSquare < 100) {
        percentDiscount = 3;
    } else if (currentSquare >= 100 && currentSquare < 200) {
        percentDiscount = 6;
    } else if (currentSquare >= 200 && currentSquare < 499) {
        percentDiscount = 10;
    } else if (currentSquare >= 500) {
        percentDiscount = 15;
    }

    if (currentSquare > 0) {
        squareResult.forEach(element => element.innerHTML = currentSquare);

        let layingValue = 5;

        let squareWithStockData = currentSquare + (currentSquare * layingValue) / 100;
        stockSquare.innerHTML = `${(squareWithStockData - currentSquare).toFixed(2)} м2 (${layingValue}%)`;
        squareWithStock.innerHTML = squareWithStockData.toFixed(2);

        let fullCountPercentDiscount = currentPercentDiscount + percentDiscount;

        discountPercentResult.innerHTML = numberFormat(fullCountPercentDiscount, 2, '.');
        discountAction.innerHTML = numberFormat(currentPercentDiscount, 2, '.');

        let block = document.querySelector('.js_discount');
        block.innerHTML = percentDiscount.toFixed(2);
    }
};
const parsNumericValue = input => (input).replace(/[^0-9,.]/g, '').replace(',', '.');

square.addEventListener('input', () => {
    let rawData = parsNumericValue(square.value);
    square.value = rawData;
    if (rawData.length) {
        let value = parseFloat(rawData);
        if (value > 0) {
            let side = Math.sqrt(value).toFixed(2);
            lengthInput.value = side;
            width.value = side;
            printData();
        }
    }
});

lengthInput.addEventListener('input', () => {
    let rawData = parsNumericValue(lengthInput.value);
    lengthInput.value = rawData;
    if (rawData.length) {
        let value = parseFloat(rawData);
        if (value > 0 && parseFloat(width.value)) {
            square.value = value * parseFloat(width.value);
            printData();
        }
    }
});

width.addEventListener('input', () => {
    let rawData = parsNumericValue(width.value);

    width.value = rawData;
    if (rawData.length) {
        let value = parseFloat(rawData);
        if (value > 0 && parseFloat(lengthInput.value)) {
            square.value = value * parseFloat(lengthInput.value);
            printData();
        }
    }
});

let tabsData = async () => await import('./Components/tabs');
tabsData().then(e => e.init(".modal-kp__tabs"));

const selectedProductEvent = (item) => {
    let price = parseFloat(item.dataset.price);
    let image = item.dataset.image;
    let discount = parseFloat(item.dataset.discount);
    let url = item.dataset.url;
    let options = JSON.parse(item.dataset.options);
    let title = item.dataset.title;
    product.value = item.dataset.id;

    if (price > discount) {
        discountPercentResult.dataset.discount = 100 / (price / (price - discount));
    } else {
        discountPercentResult.dataset.discount = 0;
    }

    wholesalesProductBlock.innerHTML = productTemplate(url, title, image, price, discount, options);

    wholesalesProductBlock.querySelectorAll('.js_open_wholesales_form')
        .forEach(item => item.addEventListener('click', event => openFormEvent(event.target)));
    if (currentmodal) {
        currentmodal.hide();
    }

    printData();
};
const initSelectedProductEvents = () => document.querySelectorAll('.js_selected_product_button').forEach(item => {
    if (item.hasEventListener('click') === false) {
        item.addEventListener('click', selectedProductEvent.bind(null, item));
    }
});

events.addListener('filter.search', null, initSelectedProductEvents);

document.querySelectorAll('[name="special-offer"]').forEach(item => {
    item.addEventListener('submit', event => {
        event.preventDefault();
        const button = item.querySelector('button[type="submit"]');

        const formData = new FormData(event.target);
        const data = Array.from(formData.entries()).reduce((memo, [key, value]) => ({
            ...memo,
            [key]: value,
        }), {});
        button.classList.add('preloader');
        Agent.post('api/v1/wholesales/send', JSON.stringify(data),  {
            headers: { 'Content-Type': 'application/json;'}
        }).then(response => response.json()).then(result => {
            if(result.success){
                event.target.reset();
            }
            notice(result.message);
        }).finally(() => button.classList.remove('preloader'));
    });
});